import { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { store } from '../store/store';

export enum QueryParamEnum {
  AWC = 'awc',
  GEO_LOCATION = 'geoLocation',
  SUBSCRIPTION_UUID = 'subscriptionuuid',
}

export const getQueryParams = (): {
  awc: string | null;
  geoLocation?: string | null;
  uuid: string | null;
  searchParams: URLSearchParams;
} => {
  const [searchParams] = useSearchParams();
  const { domain } = useContext(store);
  if (domain.includes('cetelem.fr')) {
    return {
      awc: searchParams.get(QueryParamEnum.AWC),
      uuid: searchParams.get(QueryParamEnum.SUBSCRIPTION_UUID),
      searchParams,
    };
  } else {
    return {
      awc: searchParams.get(QueryParamEnum.AWC),
      geoLocation: searchParams.get(QueryParamEnum.GEO_LOCATION),
      uuid: searchParams.get(QueryParamEnum.SUBSCRIPTION_UUID),
      searchParams,
    };
  }
};
